import zzc from './zzc';


const backToPreviousPage = (options = {}) => {
  zzc.call('BackToPreviousPage', options);
};

export default backToPreviousPage;
